import { Box, Divider, Image, Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

interface DocumentFormatLogoProps {
  logoUrl?: string;
  alt?: string;
}

export function DocumentFormatLogo({ logoUrl, alt = 'Practice logo' }: DocumentFormatLogoProps): JSX.Element | null {
  if (!logoUrl) return null;
  return (
    <Box ta="center" mb="md">
      <Image
        src={logoUrl}
        alt={alt}
        maw={220}
        mah={80}
        fit="contain"
        mx="auto"
      />
    </Box>
  );
}

interface DocumentFormatFooterProps {
  footerText?: string;
}

export function DocumentFormatFooter({ footerText }: DocumentFormatFooterProps): JSX.Element | null {
  if (!footerText) return null;
  return (
    <>
      <Divider />
      <Text size="xs" c="dimmed" ta="center" style={{ whiteSpace: 'pre-line' }}>
        {footerText}
      </Text>
    </>
  );
}

interface DocumentFormatShellProps {
  logoUrl?: string;
  footerText?: string;
  children: ReactNode;
}

/** Wraps document content with practice logo above and resolved footer below the body. */
export function DocumentFormatShell({
  logoUrl,
  footerText,
  children,
}: DocumentFormatShellProps): JSX.Element {
  return (
    <Stack gap="md">
      <DocumentFormatLogo logoUrl={logoUrl} />
      <Stack gap="md">
        {children}
        <DocumentFormatFooter footerText={footerText} />
      </Stack>
    </Stack>
  );
}
